import { createActions } from "redux-actions";

const actions = createActions({
    UPDATE_USERS: (data) => ({data}),
    GET_USER_INFO: (data)=>({data}),
    DELETE_USER: (data) => ({data}),
    ADD_USER: (data) =>({data})
})

export const updateUsers = actions.updateUsers;
export const deleteUser = actions.deleteUser;
export const getUserInfo = actions.getUserInfo;
export const addUser = actions.addUser;